<template>
  <div class="item-list">
    <div class="header">
      <div class="title-desc">
        <h5 class="p-1 m-0" :style="formatColor">
          {{ title }}
        </h5>
        <div class="ml-2">
          {{ description }}
        </div>
      </div>
      <slot name="buttons"> </slot>
    </div>
    <div class="cards">
      <slot name="cards"></slot>
    </div>
    <div class="top-buttons">
      <slot name="top-buttons"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'item-list',

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
  },

  computed: {
    formatColor() {
      if (this.color) {
        return `background-color: ${this.color}; color: white`
      }
      return 'color: dark'
    },
  },
}
</script>

<style scoped></style>
